import api from '../services/APIService';
import LocalStorageService from "@/services/LocalStorageService";
import store from '../store';

const ifAuthenticated = async (to, from, next) => {
	if(to.name == 'RegisterEventLegacy') {
		LocalStorageService.setItem('next_link', to);
	}
	api.fetch({ method: 'get', path: '/participant' })
	.then(function (response) {
		if (!response || !response.data) {
			next({ name: 'Login' });
			return;
		}

		if (response.data.message != 'not_found' && response.data.message != 'user_is_guest') {
			if(response.data.message.permissionName == "Participant") {
				next();
			} else if(response.data.message.permissionName == "Promoter")
				window.location.href = store.getters.env.get('VUE_APP_ROOT') + '/admin/promoterDashboard';
			else if(response.data.message.permissionName == "Organizer")
				window.location.href = store.getters.env.get('VUE_APP_ROOT') + '/admin/organizerDashboard';
			else {
				next();
			}
			return;
		} else {
			if (window.location.pathname == '/forgotPassword') next({ name: 'ForgotPassword' });
			else {
				if(!response.data.success) {
					next({ name: 'Login' });
				}
			}
		}
	})
	.catch(function () {
		next({ name: 'Login' });
	});

};

const isAge18 = async (to, from, next) => {
	await api.fetch({ method: 'get', path: '/users/current' })
	.then(function (response) {
		store.dispatch('setUserValueAction',response.data.message);
		store.dispatch('setAge18Action');
		if(!store.getters.age18) {
			next({ name: 'Error' });
		}
		next();
	});
	next();
};

const routes = [
	{
		path: '/',
		component: () => import('@/components/layouts/Main.vue'),
		redirect: '/dashboard',
		children: [
			{
				path: 'dashboard',
				name: 'Dashboard',
				component: () => import('@/pages/Dashboard.vue'),
				meta:{
					breadcrumb:[
						{name: 'dashboard' }
					]
				}
			},
			{
				path: 'profile',
				name: 'Profile',
				component: () => import('@/pages/Profile.vue'),
				meta:{
					breadcrumb:[
						{name: 'profile'}
					]
				}
			},
			{
				path: 'membershipWaivers',
				name: 'MembershipWaivers',
				component: () => import('@/pages/MembershipWaivers.vue'),
				meta:{
					breadcrumb:[
						{name: 'membership', linkClass: true},
						{name: 'waivers'}
					]
				}
			},
			{
				path: 'createSignatory/:id',
				name: 'CreateSignatory',
				component: () => import('@/pages/CreateSignatory.vue'),
				meta:{
					breadcrumb:[
						{name: 'create_signatory'}
					]
				}
			},
			{
				path: 'transponder',
				name: 'Transponder',
				component: () => import('@/pages/Transponder.vue'),
				meta:{
					breadcrumb:[
						{name: 'transponder'}
					]
				}
			},
			{
				path: 'vehicles',
				name: 'Vehicles',
				component: () => import('@/pages/Vehicles.vue'),
				meta:{
					breadcrumb:[
						{name: 'vehicles'}
					]
				}
			},
			{
				path: 'sponsors',
				name: 'Sponsors',
				component: () => import('@/pages/Sponsors.vue'),
				meta:{
					breadcrumb:[
						{name: 'sponsors'}
					]
				}
			},
			{
				path: 'social',
				name: 'Social',
				component: () => import('@/pages/Social.vue'),
				meta:{
					breadcrumb:[
						{name: 'social'}
					]
				}
			},
			{
				path: 'emergencycontact',
				name: 'EmergencyContact',
				component: () => import('@/pages/EmergencyContact.vue'),
				meta:{
					breadcrumb:[
						{name: 'emergency_contact', linkClass: true},
						{name: 'contact'}
					]
				}
			},
			{
				path: 'emergencyinfo',
				name: 'EmergencyInfo',
				component: () => import('@/pages/EmergencyInfo.vue'),
				meta:{
					breadcrumb:[
						{name: 'emergency_contact', linkClass: true},
						{name: 'emergency_info'}
					]
				}
			},
			{
				path: 'membership',
				name: 'Membership',
				component: () => import('@/pages/Membership.vue'),
				meta:{
					breadcrumb:[
						{name: 'membership', linkClass: true},
						{name: 'your_membership'}
					]
				}
			},
			{
				path: 'membership/classes',
				name: 'MembershipClasses',
				component: () => import('@/pages/membership/Classes.vue'),
				meta:{
					breadcrumb:[
						{name: 'membership', linkClass: true},
						{name: 'manage_classes'}
					]
				}
			},
			// Archived flow (see #83). The old /membershipRegistration route is the
			// iframe path that occasionally served stale registration code. Any bookmark,
			// email link, or cached iframe src now redirects to /memberRegistration so
			// users can never land on the old flow again. The component file and its
			// store module have been deleted; only these redirects remain for URL
			// compatibility.
			{
				path: 'membershipRegistration',
				redirect: { name: 'MemberRegistration' }
			},
			{
				path: 'membershipRegistration/:orgId',
				redirect: to => ({
					name: 'MemberRegistrationWithTarget',
					params: { orgId: to.params.orgId }
				})
			},
			{
				path: 'registeredMembers',
				name: 'RegisteredMembers',
				component: () => import('@/pages/RegisteredMembers.vue'),
				meta:{
					breadcrumb:[
						{name: 'membership', linkClass: true},
						{name: 'registered_members'}
					]
				}
			},
			{
				path: 'memberRegistration',
				name: 'MemberRegistration',
				component: () => import('@/pages/memberRegistration.vue'),
				meta:{
					breadcrumb:[
						{name: 'membership', linkClass: true},
						{name: 'member_registration'}
					]
				}
			},
			{
				path: 'memberRegistration/:status/:token',
				name: 'MemberRegistrationComplete',
				component: () => import('@/pages/memberRegistration.vue'),
				meta:{
					breadcrumb:[
						{name: 'membership', linkClass: true},
						{name: 'member_registration'}
					]
				}
			},
			{
				path: 'memberRegistration/:orgId',
				name: 'MemberRegistrationWithTarget',
				component: () => import('@/pages/memberRegistration.vue'),
				meta:{
					breadcrumb:[
						{name: 'membership', linkClass: true},
						{name: 'member_registration'}
					]
				}
			},
			{
				path: 'joinClubPP',
				name: 'JoinedClubPP',
				component: () => import('@/pages/JoinedClubPP.vue'),
				meta:{
					breadcrumb:[]
				}
			},
			{
				path: 'joinedClub',
				name: 'JoinedClub',
				component: () => import('@/pages/JoinedClub.vue'),
				meta:{
					breadcrumb:[]
				}
			},
			{
				path: 'joinorganization',
				name: 'JoinOrganization',
				component: () => import('@/pages/JoinOrganization.vue'),
				meta:{
					breadcrumb:[
						{name: 'profile', link:'profile'},
						{name: 'join_organization'}
					]
				}
			},
			{
				path: 'registerEventLegacy',
				name: 'RegisterEventLegacy',
				component: () => import('@/pages/event/EventRegistrationLegacy.vue'),
				meta:{
					breadcrumb:[
						{name: 'events', linkClass: true},
						{name: 'register_event_legacy'}
					]
				}

			},
			{
				path: 'registerEventLegacy/:eventId',
				name: 'RegisterEventLegacyWithId',
				component: () => import('@/pages/event/EventRegistrationLegacyId.vue'),
				meta:{
					breadcrumb:[
						{name: 'events', linkClass: true},
						{name: 'register_event_legacy'}
					]
				}

			},
			{
				path: 'registeredParticipants',
				name: 'RegisteredParticipants',
				component: () => import('@/pages/event/RegisteredParticipants.vue'),
				meta:{
					breadcrumb:[
						{name: 'events', linkClass: true},
						{name: 'registered_participants'}
					]
				}
			},
		/* DEPRECATED — route disabled. The active registration flow is
		   EventRegistrationLegacy.vue (route: registerEventLegacy).
		   See pages/event/EventRegistration.vue header for details.
		{
			path: 'registerEventDashboard',
			name: 'RegisterEventDashboard',
			component: () => import('@/pages/event/EventRegistration.vue'),
			meta:{
				breadcrumb:[
					{name: 'register', linkClass: true},
					{name: 'register_event'}
				]
			}
		},*/
			{
				path: 'yourRegistration',
				name: 'YourRegistration',
				component: () => import('@/pages/event/YourRegistration.vue'),
				meta:{
					breadcrumb:[
						{name: 'events', linkClass: true},
						{name: 'your_registration'}
					]
				}
			},
			{
				path: 'unPaidRegistrationDashboard',
				name: 'UnPaidRegistrationDashboard',
				component: () => import('@/pages/UnPaidRegistration.vue'),
				meta:{
					breadcrumb:[
						{name: 'events', linkClass: true},
						{name: 'un_paid_registration'}
					]
				}
			},
			{
				path: 'paymentDashboard',
				name: 'PaymentDashboard',
				component: () => import('@/pages/Payment.vue'),
				meta:{
					breadcrumb:[
						{name: 'register', linkClass: true},
						{name: 'un_paid_registration', link: 'unPaidRegistrationDashboard'},
						{name: 'payment'}
					]
				}
			},
			{
				path: 'completeRegistration',
				name: 'complete_registration',
				component: () => import('@/pages/CompleteRegistration.vue'),
			},
			{
				path: 'incompleteRegistration',
				name: 'incomplete_registration',
				component: () => import('@/pages/IncompleteRegistration.vue'),
			},
			{
				path: 'completeYourRegistration',
				name: 'CompleteYourRegistration',
				component: () => import('@/pages/CompleteYourRegistration.vue'),
			},
			{
				path: 'canceledRegistration',
				name: 'canceled_registration',
				component: () => import('@/pages/CanceledRegistration.vue'),
			},
			{
				path: 'cancelRegistration',
				name: 'cancelregistrationiframe',
				component: () => import('@/pages/CancelRegistration.vue'),
			},
			{
				path: 'viewRegistration/:id',
				name: 'view_registration',
				component: () => import('@/pages/event/ViewRegistration.vue')
			},
			{
				path: 'Riders',
				name: 'Riders',
				component: () => import('@/pages/Riders.vue'),
				meta:{
					breadcrumb:[
						{name: 'riders'},
					]
				}
			},
			{
				path: 'Spectators',
				name: 'Spectators',
				component: () => import('@/pages/Spectators.vue'),
				meta:{
					breadcrumb:[
						{name: 'spectators'},
					]
				}
			},
			{
				path: 'error',
				name: 'Error',
				component: () => import('@/pages/Error.vue')
			},
			{
				path: 'ridersCreate',
				name: 'RidersCreate',
				component: () => import('@/components/Riders/CreateRider.vue'),
				meta:{
					breadcrumb:[
						{name: 'riders', link:'Riders'},
						{name: 'riders_create'}
					]
				},
				beforeEnter: isAge18
			},
			{
				path: 'spectatorsCreate',
				name: 'SpectatorsCreate',
				component: () => import('@/pages/Spectators/CreateSpectator.vue'),
				meta:{
					breadcrumb:[
						{name: 'spectators', link:'Spectators'},
						{name: 'spectators_create'}
					]
				},
				beforeEnter: isAge18
			},
			{
				path: 'billing',
				name: 'Billing',
				component: () => import('@/pages/Billing.vue'),
				meta:{
					breadcrumb:[
						{name: 'billing'}
					]
				}
			},
			{
				path: 'authorization',
				name: 'Authorization',
				component: () => import('@/pages/profile/Authorization.vue'),
				meta:{
					breadcrumb:[
						{name: 'authorization'}
					]
				}
			},
			{
				path: 'createAuthorization',
				name: 'CreateAuthorization',
				component: () => import('@/pages/profile/CreateAuthorization.vue'),
				meta:{
					breadcrumb:[
						{name: 'authorization', link: 'Authorization'},
						{name: 'create_authorization' },
					]
				}
			},
			{
				path: 'results',
				name: 'Results',
				component: () => import('@/pages/Results.vue'),
				meta:{
					breadcrumb:[
						{name: 'results', linkClass: true},
						{name: 'participant_results'}
					]
				}
			},
			{
				path: '/results-details',
				name: 'ResultsDetails',
				component: () => import('@/pages/ResultsDetails.vue'),
				meta:{
					breadcrumb:[
						{name: 'results', linkClass: true},
						{name: 'results_details'}
					]
				}
			},
			{
				path: '/eventRegistration',
				name: 'EventRegistration',
				component: () =>  import('@/pages/EventRegistration.vue'),
				meta:{
					breadcrumb:[
						{name: 'register', linkClass: true},
						{name: 'register_event_legacy'}
					]
				}
			},
			{
				path: 'eventWaivers',
				name: 'EventWaiver',
				component: () => import('@/pages/events/Waivers.vue'),
				meta:{
					breadcrumb:[
						{name: 'events', linkClass: true},
						{name: 'event_waiver'}
					]
				}
			},
			{
				path: 'eventWaiverCreate',
				name: 'EventWaiverCreate',
				component: () => import('@/pages/events/Waivercreate.vue'),
				meta:{
					breadcrumb:[
						{name: 'events', linkClass: true},
						{name: 'event_waiver'}
					],
					openMenu: 'EventWaiver'
				}
			},
			{
				path: 'canceledMembership',
				name: 'canceled_membership',
				component: () => import('@/pages/CanceledMembership.vue'),
				meta:{
					breadcrumb:[
						{name: 'register', linkClass: true},
						{name: 'member_registration'}
					]
				}
			}
		],
		beforeEnter: ifAuthenticated,
	},
	{
		path: '/unPaidRegistration',
		name: 'UnPaidRegistration',
		redirect: '/unPaidRegistrationDashboard',
		components: {
			default: () => import('@/pages/UnPaidRegistration.vue'),
			Header: () => import('@/components/layouts/Header.vue'),
		},
		beforeEnter: ifAuthenticated
	},
	{
		path: '/payment',
		name: 'Payment',
		components: {
			default: () => import('@/pages/Payment.vue'),
			Header: () => import('@/components/layouts/Header.vue'),
		},
		beforeEnter: ifAuthenticated
	},
	{
		path: '/login',
		name: 'Login',
		component: () => import('@/pages/Login.vue'),
	},
	{
		path: '/forgotPassword',
		name: 'ForgotPassword',
		component: () => import('@/pages/ForgotPassword.vue'),
	},
	{
		path: '/resetPassword',
		name: 'ResetPassword',
		component: () => import('@/pages/ResetPassword.vue'),
	},
	{ 
		path: '*', 
		components: {
			default: () => import('@/pages/errors/Error404.vue'),
			Header: () => import('@/components/layouts/Header.vue')
		}
	}
];

export default routes;
